import CreateInputTextArea from '../../../utils/build/CreateInputTextArea.js';
export default CreateInputTextArea;